import { themeAtom } from "../../shared/atoms";
import AdminOnboardingDeleteModal from "../components/debug/AdminOnboardingDeleteModal";
import AdminOnboardingGrid from "../components/debug/AdminOnboardingGrid";
import AdminOnboardingTopBar from "../components/debug/AdminOnboardingTopBar";
import { useAdminOnboarding } from "../hooks/useAdminOnboarding";
import { filterAdminOnboardingRows } from "../utils/admin-onboarding.utils";
import { useAtomValue } from "jotai";
import { useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";

// Exposes the onboarding ledger in Debug with the same compact toolbar and custom grid as other admin tables.
const AdminOnboardingPage = () => {
  const theme = useAtomValue(themeAtom);
  const onboarding = useAdminOnboarding();
  const [search, setSearch] = useState("");
  const rows = useMemo(() => filterAdminOnboardingRows(onboarding.rows, search), [onboarding.rows, search]);

  return (
    <main
      data-test="admin-onboarding-page"
      className={twMerge("flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden", theme.home.tailwind.textDefault)}
    >
      <AdminOnboardingTopBar
        search={search}
        rowCount={rows.length}
        totalCount={onboarding.rows.length}
        disabled={onboarding.loading || onboarding.deleting}
        onSearch={setSearch}
        onRefresh={onboarding.refresh}
      />
      <p className="border-b border-gray-200 px-3 py-2 text-xs opacity-75 dark:border-gray-700">
        Delete a vessel's onboarding records to allow it to be ingested again with an updated source email.
      </p>
      {onboarding.loading && (
        <p role="status" data-test="admin-onboarding-loading" className="px-3 py-2 text-sm">
          Loading onboarding records...
        </p>
      )}
      {onboarding.errorMessage && (
        <p role="alert" data-test="admin-onboarding-error" className="px-3 py-2 text-sm text-[#BF0002]">
          {onboarding.errorMessage}
        </p>
      )}
      {onboarding.actionMessage && (
        <p role="status" data-test="admin-onboarding-result" className="px-3 py-2 text-sm">
          {onboarding.actionMessage}
        </p>
      )}
      <AdminOnboardingGrid
        rows={rows}
        disabled={onboarding.loading || onboarding.deleting || Boolean(onboarding.errorMessage)}
        onDeleteVessel={onboarding.selectVessel}
      />
      {onboarding.confirmationRows.length > 0 && (
        <AdminOnboardingDeleteModal
          rows={onboarding.confirmationRows}
          deleting={onboarding.deleting}
          errorMessage={onboarding.modalError}
          onClose={onboarding.closeConfirmation}
          onConfirm={onboarding.confirmDeletion}
        />
      )}
    </main>
  );
};

export default AdminOnboardingPage;
